import { defineComponent as _defineComponent } from 'vue'
import { httpRequest } from '@/apis/request'
import { deleteTask, refuseTask, saveTaskToHistory } from '@/apis/taskList'
import GBaseModal from '@/components/g-base-modal.vue'
import { translate } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import Vue from 'vue'
import { ref } from 'vue'

import { TaskType } from '../types/taskCard'
import { createTask, dealFileData } from '../util/dealData'
import mEmpty from './m-empty.vue'
import mTaskCard from './m-task-card.vue'

interface PropsType {
  taskList: TaskType[]
  total: number
  isLoading: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-task-list',
  props: {
    taskList: null,
    total: null,
    isLoading: { type: Boolean }
  },
  emits: ['onTaskPageChange', 'onClcikRefuseHistory'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as {
  taskList: TaskType[]
  total: number
  isLoading: boolean
}




const filterType = ref(0)
const taskSearchText = ref('')
const taskSearchType = ref('order_name')
const currentTaskPage = ref(1)
const fileUploadRef = ref()
const isShowWorning = ref(false)
const isLoadingPlank = ref(false)
const saveTipModal = ref<any>()
const taskDetailList = ref<any>({})

const taskTypeList = ref<{ label: string; value: number }[]>([
  { label: 'common.all', value: 0 },
  { label: 'taskPage.filter.unArrange', value: 1 },
  { label: 'taskPage.filter.arranged', value: 2 },
])
function handleFilterTask() {
  taskSearchText.value = ''
  currentTaskPage.value = 1
  emits('onTaskPageChange', 1, 0, { has_paiban: filterType.value })
  buryPointApi('task', 'filter_task')
}
function translateLang(key: string) {
  return translate(key)
}

async function handleTaskChangePage(page: number) {
  currentTaskPage.value = page
  refetchCurrentPage()
}

function handleAddtoBatchList() {
  refetchCurrentPage()
  emits('onTaskPageChange', 1, 2)
}

function handleSearch() {
  currentTaskPage.value = 1
  refetchCurrentPage(1)
  buryPointApi('task', 'search_task')
}

function refetchCurrentPage(page?: number) {
  if (page) {
    currentTaskPage.value = page
  }
  const obj: { [key: string]: any } = {}
  obj['has_paiban'] = filterType.value
  if (taskSearchText.value) {
    obj[taskSearchType.value] = taskSearchText.value
    emits('onTaskPageChange', page ? page : currentTaskPage.value, 0, obj)
  } else {
    emits('onTaskPageChange', page ? page : currentTaskPage.value, 0, obj)
  }
}

function handleImportTask() {
  fileUploadRef.value.value = ''
  fileUploadRef.value.dispatchEvent(new MouseEvent('click'))
}

function onInputFileData(e: any) {
  if (e.target.files.length) {
    const file = e.target.files[0]
    isLoadingPlank.value = true
    dealFileData(file, async (res: any) => {
      if (res && res.status) {
        await createTask(res.plankList)
        isLoadingPlank.value = false
        refetchCurrentPage(1)
      } else if (res.errText) {
        isLoadingPlank.value = false
        Vue.prototype.$antdConfirm({
          title: '提示',
          content: res.errText,
          okText: '确认',
          cancelText: '取消',
          centered: true,
        })
      } else {
        isLoadingPlank.value = false
      }
    })
  }
}

function handleConfirmWorning() {
  isShowWorning.value = false
}

function handleRefreshList() {
  currentTaskPage.value = 1
  taskSearchText.value = ''
  filterType.value = 0
  emits('onTaskPageChange', 1)
  emits('onTaskPageChange', 1, 2)
  buryPointApi('task', 'refresh_task_list')
}

function handleTaskWarning(isShow: boolean) {
  isShowWorning.value = isShow
}

function handleClickRefuseHistory() {
  emits('onClcikRefuseHistory')
}

async function handleSaveToHistory(task: TaskType) {
  saveTipModal.value = Vue.prototype.$antdConfirm({
    title: '提示',
    content: '是否完成订单并放入存档?',
    okText: '存档',
    cancelText: '取消',
    centered: true,
    closable: true,
    onOk: async () => {
      saveTipModal.value.destroy()
      setTimeout(async () => {
        isLoadingPlank.value = true
        const json = task.paiban_json ?? ''
        const paibanJson = await httpRequest.get(json)
        const res = await saveTaskToHistory({
          task_ids: [task.id],
          platform: task.platform,
          batch_id: task.batch_id,
          task_batch: task.batchNumber,
          process_id: paibanJson.process_setting_id,
        })
        isLoadingPlank.value = false
        if (res.status) {
          Vue.prototype.$message.success('保存成功')
          refetchCurrentPage()
        } else {
          Vue.prototype.$message.error('保存失败，请稍后重试!')
        }
      })
    },
  })
}

async function handleRefuseTask(task: TaskType, refuseReson: string) {
  const res = await refuseTask({
    task_ids: [task.id],
    refuse_reason: refuseReson,
    platform: task.platform,
  })
  refetchCurrentPage()
  if (res.status == 1) {
    Vue.prototype.$message.success('拒绝成功')
  } else {
    Vue.prototype.$message.error('操作失败,请稍后再试!')
  }
}
async function handleDeleteTask(task: TaskType) {
  const res = await deleteTask({ task_ids: [task.id] })
  refetchCurrentPage()
  if (res.status == 1) {
    Vue.prototype.$message.success('删除成功!')
  } else {
    Vue.prototype.$message.error('删除失败,请稍后重试!')
  }
}
expose({ refetchCurrentPage })

return { __sfc: true,props, emits, filterType, taskSearchText, taskSearchType, currentTaskPage, fileUploadRef, isShowWorning, isLoadingPlank, saveTipModal, taskDetailList, taskTypeList, handleFilterTask, translateLang, handleTaskChangePage, handleAddtoBatchList, handleSearch, refetchCurrentPage, handleImportTask, onInputFileData, handleConfirmWorning, handleRefreshList, handleTaskWarning, handleClickRefuseHistory, handleSaveToHistory, handleRefuseTask, handleDeleteTask, GBaseModal, mEmpty, mTaskCard }
}

})